import {
  Avatar,
  Badge,
  Box,
  Button,
  Slider,
  Card,
  CardHeader,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Paper,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  TextField,
  MenuItem,
  CardContent,
  Select,
  FormControl,
  InputLabel,
  Snackbar
} from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import SendIcon from '@material-ui/icons/Send';
import CropFreeIcon from '@material-ui/icons/CropFree';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SettingsRemoteIcon from '@material-ui/icons/SettingsRemote';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { SwipeableListItem } from '@sandstreamdev/react-swipeable-list';
import '@sandstreamdev/react-swipeable-list/dist/styles.css';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import PropTypes from 'prop-types';
import React, { useEffect, Fragment } from 'react';
import moment from 'moment';
import { Chart } from 'react-charts';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import DeleteIcon from '@material-ui/icons/Delete';
import DoneIcon from '@material-ui/icons/Done';
import {
  getHistoricalMaterialRequest,
  setCurrentDefect,
  setDefectFilterKey,
  setLabourFilterKey,
  setLabourSelection,
  setMaterialFilterKey,
  setMaterialSelection
} from '../store/actions';
import { setTask } from '../store/actions/taskActions';
import BarkodPopup from './BarcodePopup';
import ComplexSwipeContent from './ComplexSwipeContent';
import Dezenfeksiyon from './Disinfection';
import SelectDefect from './SelectDefect';
import SelectLabour from './SelectLabour';
import SelectMaterial from './SelectMaterial';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import VirtualStockPanel from './VirtualStockPanel';
import Alert from 'src/components/Alert';
import {
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest,
  resetLabours,
  resetMaterials,
  resetDefects
} from '../../src/store/actions';

import { getUser, openBlob, moneyFormat, RoundKm } from 'src/utils/Common';

let transportPromiseCache = {};

const useStyles = makeStyles(theme => ({
  root: {},
  ListDiv: {
    backgroundColor: theme.palette.common.siyah
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  error: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.error.contrastText
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium
  },
  type: {
    fontWeight: theme.typography.fontWeightMedium
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  pageStyle: {
    display: 'flex',
    padding: '2px 4px'
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    height: 28,
    margin: 4
  },
  searchButton: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  content: {
    marginLeft: theme.spacing(0)
  },
  nested: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  nestedRight: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(7)
  },
  smallIcon: {
    height: 15,
    width: 15
  },
  toplam: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    align: 'right',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  action: {
    paddingTop: 12
  },
  submitButtonWudaq: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    width: '50%'
  },
  cardsMax: {
    maxHeight: 550,
    minHeight: 550
  }
}));

const defaultProps = {
  bgcolor: 'background.paper',
  // borderColor: "grey.500",
  borderColor: '#1D3343',
  border: 1,
  marginLeft: 0.5,
  marginRight: 0.5,
  marginBottom: 0.5
};

const defaultPropsChild = {
  bgcolor: 'background.paper',
  borderColor: '#cfcfcf',
  border: 1,
  marginLeft: 0.5,
  marginRight: 0.5,
  marginBottom: 0.5
};

const SmallAvatar = withStyles(theme => ({
  root: {
    width: 20,
    height: 20
    // border: `2px solid ${theme.palette.background.paper}`,
  }
}))(Avatar);

function HizmetPage(props) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [openDefect, setOpenDefect] = React.useState(false);
  const [openMaterial, setOpenMaterial] = React.useState(false);
  const [openLabour, setOpenLabour] = React.useState(false);
  const [materialSum, setMaterialSum] = React.useState(0);
  const [labourSum, setLabourSum] = React.useState(0);
  const [materialVatSum, setMaterialVatSum] = React.useState(0);
  const [labourVatSum, setLabourVatSum] = React.useState(0);
  const [stokOpen, setStokOpen] = React.useState(false);
  const [NonIotOpen, setNonIotOpen] = React.useState(false);
  const [SoftwareDownloadOpen, setSoftwareDownloadOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [stokData, setStokData] = React.useState([]);
  const [stokDataOwnEngineer, setStokDataOwnEngineer] = React.useState([]);
  const [GosterimAdet, setGosterimAdet] = React.useState(30);
  const [open, setOpen] = React.useState(false);
  const [grafikGetir, setgrafikGetir] = React.useState(true);
  const [PriceControlButton, setPriceControlButton] = React.useState(false); //serdar
  const [Uyari, setUyari] = React.useState('');
  const [OpenBarkodkart, setOpenBarkodkart] = React.useState(false);
  const [OpenBarkodCihaz, setOpenBarkodCihaz] = React.useState(false);
  const [ExtraOpen, setExtraOpen] = React.useState(false);
  const [VatOpen, setVatOpen] = React.useState(false);
  const [selectedVat, setSelectedVat] = React.useState('');
  const [vatRates, setVatRates] = React.useState([]);
  const [uyariAciklama, setUyariAciklama] = React.useState('');
  const [uyariTip, setUyariTip] = React.useState();
  const [ExtraPaymentId, setExtraPaymentId] = React.useState(3);
  const [TotalExtraPrice, setTotalExtraPrice] = React.useState(0.0);
  const [ExtraPaymentTypeData, setExtraPaymentTypeData] = React.useState([]);
  const [ExtraPaymentDetailDsc, setExtraPaymentDetailDsc] = React.useState('');
  const [Km, setKm] = React.useState(0);
  const [TotalExtraNewPriceParam, setTotalExtraNewPriceParam] = React.useState(0);
  const [extraFeeNote, setExtraFeeNote] = React.useState('');
  const [TotalExtraNewPrice, setTotalExtraNewPrice] = React.useState(0.00);
  const [materialCode, setMaterialCode] = React.useState([]);
  const SessionUser = getUser();
  const [backButtonVisible, setBackButtonVisible] = React.useState(false);
  const [stockMsg, setStockMsg] = React.useState('');
  const [serviceShopTypeId, setServiceShopTypeId] = React.useState();
  const [IsAllOwnEngineer, setIsAllOwnEngineer] = React.useState(false);
  const [automaticDistanceCalculationIsActive, setAutomaticDistanceCalculationIsActive] = React.useState(false);
  
  const [expandedPanel, setExpandedPanel] = React.useState(null);
  const togglePanel = code => setExpandedPanel(prev => (prev === code ? null : code));
  
  const [virtualStockEnabled, setVirtualStockEnabled] = React.useState(false);
  const [virtualStockEnabledLoaded, setVirtualStockEnabledLoaded] = React.useState(false);

  useEffect(() => {
    axios
      .get('/IsVirtualStockEnabled')
      .then(r => {
        setVirtualStockEnabled(r.data === true);
        setVirtualStockEnabledLoaded(true);
      })
      .catch(() => {
        setVirtualStockEnabled(false);
        setVirtualStockEnabledLoaded(true);
      });
  }, []);

  const [KartBarcode, setKartBarcode] = React.useState('');
  const [CihazBarcode, setCihazBarcode] = React.useState('');
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    let currMaterialSum = 0;
    let currLabourSum = 0;
    let currMaterialVatSum = 0;
    let currLabourVatSum = 0;
    if (props.defects && props.defects.selected) {
      props.defects.selected.forEach((row, index) => {
        if (props.materials && props.materials.materialsTable) {
          if (props.materials[row]) {
            props.materials[row].forEach((mrow, index) => {
              currMaterialSum +=
                props.materials[mrow] *
                props.materials.materialsTable[mrow]?.PriceWithWat;
              currMaterialVatSum +=
                props.materials[mrow] *
                props.materials.materialsTable[mrow]?.Price;
            });
          }
        }
        if (props.labours && props.labours.laboursTable) {
          if (props.labours[row]) {
            props.labours[row].forEach((mrow, index) => {
              currLabourSum +=
                props.labours.laboursTable[mrow]?.PriceWithWat;
              currLabourVatSum +=
                props.labours.laboursTable[mrow]?.Price;
            });
          }
        }
      });
    }

    if (props.tasks.tasks[0]?.WarrantyTypeId === 471) {
      currMaterialVatSum = 0;
      currMaterialSum = 0;
    }

    setMaterialSum(currMaterialSum);
    setLabourSum(currLabourSum);
    setMaterialVatSum(currMaterialVatSum);
    setLabourVatSum(currLabourVatSum);

    //serdar
    var ControlTotalPriceParam = currMaterialSum + currLabourSum +
      (props.tasks.tasks[0]?.WorkOrderTransport?.length > 0
        ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPriceWithWat || 0
        : 0)
      +
      (props.tasks.tasks[0]?.WorkOrderExtra?.length > 0
        ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPriceWithWat || 0
        : 0);

    if (parseInt(ControlTotalPriceParam) > 0) {
      if (parseInt(props?.tasks?.tasks[0]?.TotalPrice) !== parseInt(ControlTotalPriceParam)) {
        setPriceControlButton(true);
      } else {
        setPriceControlButton(false);
      }
    }


    // eslint-disable-next-line
  }, [props.defect, props.labours, props.materials, props.tasks.tasks]);
  const IscilikSil = (Iscilik, index, Hizmet) => {
    let Uyari = `${Iscilik.LabourCode} ${Iscilik.LabourDesc} ${t('Sil')}`;
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: t('Evet'),
          onClick: () => IscilikSilEvet(Iscilik, index, Hizmet)
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  };
  const IscilikSilEvet = (Iscilik, index, Hizmet) => {
    const selected = props.labours[Hizmet] || [];
    const selectedIndex = selected.indexOf(Iscilik.LabourCode);
    let newSelected = [];
    if (selectedIndex === -1) {
      return;
    }
    newSelected = [
      ...selected.slice(0, selectedIndex),
      ...selected.slice(selectedIndex + 1)
    ];
    props.setLabourSelection(Hizmet, newSelected);
  };
  const MalzemeSil = (Malzeme, index, Hizmet) => {
    let Uyari =
      Malzeme.MaterialCode + ' ' + Malzeme.MaterialDesc + ' ' + t('Sil');
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: t('Evet'),
          onClick: () => MalzemeSilEvet(Malzeme, index, Hizmet)
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  };
  const MalzemeSilEvet = (Malzeme, index, Hizmet) => {
    const selected = props.materials[Hizmet] || [];
    const selectedIndex = selected.indexOf(Malzeme.MaterialCode);
    let newSelected = [];
    if (selectedIndex === -1) {
      return;
    }
    newSelected = [
      ...selected.slice(0, selectedIndex),
      ...selected.slice(selectedIndex + 1)
    ];

    props.setMaterialSelection(Hizmet, newSelected);
  };


  useEffect(() => {
    let mounted = true;

    const fetchTodos = () => {
      fetchSiriusTransportData();
    };
    fetchTodos();
    return () => {
      mounted = false;
    };
  }, []);

  const fetchSiriusTransportData = () => {
    let mounted = true;
    let WarrantyTypeId = props.tasks.tasks[0]?.WarrantyTypeId;
    let LocationId = 0;

    let url = '/GetSiriusTransport/' + SessionUser.ServiceShopId + '/' + WarrantyTypeId + '/' + LocationId + '/' + props.ReceiptNo;

    if (!transportPromiseCache[url]) {
      transportPromiseCache[url] = axios.get(url);
    }

    transportPromiseCache[url]
      .then(response => {
        if (mounted) {
          const Response = response.data === '' ? [] : response.data;
          setExtraPaymentTypeData(Response);
          if (props.tasks.tasks[0]?.WorkOrderTransport.length > 0) {
            setKm(
              props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count === ''
                ? ''
                : Number(props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count)
            );

            var ExtraPrice = ExtraPaymentTypeData.filter(
              x =>
                parseInt(x.Min) <=
                parseInt(
                  props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count
                ) &&
                parseInt(x.Max) >=
                parseInt(props.tasks.tasks[0]?.WorkOrderTransport[0]?.Count)
            );

            setTotalExtraPrice(
              props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPrice
            );

            setExtraPaymentDetailDsc(ExtraPrice[0]?.ExtraDesc);
          }
          setTotalExtraNewPrice(props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPrice || 0);
          setExtraFeeNote(props.tasks.tasks[0]?.WorkOrderExtra[0]?.ExtraFeeNote || '')
          setLoading(false);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  };
  
useEffect(() => {
    const fetchTodos = () => {
      axios
        .get(
          '/GetVatValues'
        )
        .then(response => {
          if (response.data.length > 0) {
            setVatRates(response.data);
          } else {
            setVatRates([]);
          }
        });
    };
    fetchTodos();
  }, []);

  function SetWorkOrderVat(newVat) {

    const WorkOrderId = parseInt(props.ReceiptNo);

    let job = props.tasks.tasks.find(
      d => parseInt(d.ReceiptNo) === parseInt(WorkOrderId)
    );

    const fakeEvent = { target: { value: 0 } };

    setLoading(true);
    axios.post('/SetWorkOrderVat/' + WorkOrderId + '/' + newVat)
      .then((response) => {
        setUyari(true);
        setUyariAciklama(t('vattype_changed_message'));
        props.resetLabours();
        props.resetMaterials();
        props.resetDefects();
        setLoading(false);
        props.getDefectRequest(job.ModelCode, 1, []);
        props.getMaterialRequest(
          job.ModelCode,
          job.WarrantyTypeId,
          1,
          0,
          0,
          job?.ReceiptNo || 0
        );
        props.getLabourRequest(job.ModelCode, job.WarrantyTypeId, 1, '', job?.ReceiptNo || 0);
        job = { ...job, HIZMETLER: [], ISCILIKLER: [], MALZEMELER: [] };
        props.setTask(job);
        deleteExtraPrice();
        handleChangeKm(fakeEvent);
        AddExtraPriceNew(fakeEvent);
        handleSliderChange(fakeEvent, 0);
        fetchSiriusTransportData();
      })
  };

  const handleNonIotOpen = () => {
    setNonIotOpen(true);
    setgrafikGetir(true);
  };
  const setNonIotChartOpen = () => {
    setgrafikGetir(false);
  };

  const handleExtraOpen = async (props) => {
    let isActive = false;
    setExtraOpen(true);
    setLoading(true);
    try {
      const response = await axios.get(`/GetDefinedValue/13`); // 13: Automatic Distance Calculation
      isActive = response.data?.Value === 1 ? true : false;
      setAutomaticDistanceCalculationIsActive(isActive);
    } catch (error) {
      isActive = false;
      setAutomaticDistanceCalculationIsActive(false);
    }


    if (isActive) {
      try {
        const response = await axios.get(`/CalculateDistanceByWorkOrderId/${props.ReceiptNo}`);
        const res = response.data;
        if (res?.KmInt) {
          let roundedKm = RoundKm(res.KmInt);
          handleSliderChange(null, roundedKm);
        }
      } catch (error) {
        console.error("Distance calculation error:", error);
      }
    }
    setLoading(false);
  };

  const handleVatOpen = props => {
    setVatOpen(true);
  };

  const handleVatChange = (event) => {
    const newVat = event.target.value;
    setSelectedVat(newVat);
    SetWorkOrderVat(newVat);
    setVatOpen(false);
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };


  const handleStokOpen = props => {
  setBackButtonVisible(false);

  let malzemeler = [];
  props.defects.selected.forEach(s => {
    if (props.materials[s] !== undefined) {
      malzemeler = [...malzemeler, ...props.materials[s]];
    }
  });
  if (malzemeler.length === 0) {
    setUyari(t('Malzeme_Seciniz_input'));
    setOpen(true);
    return;
  }
  async function fetchVirtualStockInBatches(materialCodes, batchSize = 5) {
    const SessionUser = getUser();
    const results = [];
    for (let i = 0; i < materialCodes.length; i += batchSize) {
      const batch = materialCodes.slice(i, i + batchSize);
      const batchResults = await Promise.all(batch.map(code =>
        axios.post('/GetVirtualStockAvailability', {
          MaterialCode: code,
          ServiceShopCode: SessionUser.ServiceShopCode
        })
        .then(res => ({
          MaterialCode: code,
          virtualTotal: res.data.TotalAvailableQty,
          virtualInvoices: res.data.Invoices
        }))
        .catch(() => ({
          MaterialCode: code,
          virtualTotal: 0,
          virtualInvoices: []
        }))
      ));
      results.push(...batchResults);
    }
    return results;
  }
  // ---- KEY FEATURE FLAG BRANCHING ----
  if (virtualStockEnabled) {
  setStokOpen(true);
  setLoading(true);

  fetchVirtualStockInBatches(malzemeler, 10).then(results => {
    setStokData(results);
    setMaterialCode(malzemeler);
    setLoading(false);
  });
  return; // EXIT: do NOT run classic-stock code below
}

  // ---- ELSE: CLASSIC (PHYSICAL) STOCK LOGIC ----
  setStokOpen(true);
  setLoading(true);

  GetMaterialAvailabilityOwnEngineer(false);

  const Request = {
    MaterialCode: malzemeler,
    ServiceShopCode: SessionUser.ServiceShopCode
  };
  const RequestHeaders = {
    headers: { 'Content-Type': 'application/json' }
  };
  axios
    .post('/GetMaterialAvailabilitySirius', Request, RequestHeaders)
    .then(response => {
      const res = response.data.length === 0 ? [] : response.data;
      const stokQuantity = res.map(item => ({
        ...item,
        Quantity: parseInt(item.Quantity, 10)
      }));
      setStokData(stokQuantity);
      setMaterialCode(malzemeler);
      setLoading(false);
      // There should be NO virtual stock API or processing down here.
    })
    .catch(error => {
      setLoading(false);
    });
};

  const GetMaterialAvailabilityOwnEngineer = (value) => {
    setIsAllOwnEngineer(value);

    let malzemeler = [];
    props.defects.selected.forEach(s => {
      if (props.materials[s] !== undefined) {
        malzemeler = [...malzemeler, ...props.materials[s]];
      }
    });
    if (malzemeler.length === 0) {
      setUyari(t('Malzeme_Seciniz_input'));
      setOpen(true);
      return;
    }

    setLoading(true);

    const Request = {
      MaterialCode: malzemeler,
      ServiceShopId: SessionUser.ServiceShopId,
      IsAllOwnEngineer: value
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialAvailabilityOwnEngineer', Request, RequestHeaders)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res.length > 0) {
          const stokQuantity = res.map(item => ({
            ...item,
            Quantity: parseInt(item.Quantity, 10)
          }));
          setStokDataOwnEngineer(stokQuantity);
          setServiceShopTypeId(res[0].ServiceShopTypeId);
        }
        else {
          setStokDataOwnEngineer([]);
          setStockMsg(t('lblStockMsg'))
        }

        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const StockSearch = () => {
    let malzemeler = [];
    props.defects.selected.forEach(s => {
      if (props.materials[s] !== undefined) {
        malzemeler = [...malzemeler, ...props.materials[s]];
      }
    });
    if (malzemeler.length === 0) {
      setUyari(t('Malzeme_Seciniz_input'));
      setOpen(true);
      return;
    }

    GetMaterialAvailabilityOwnEngineer(true);
    setBackButtonVisible(true);
  }

  const getStokColor = s => {
    if (s.Quantity > 0) {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"
          onClick={() => {
            setUyari(s.Date || '');
            setOpen(true);
          }}
          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };

  const axes = React.useMemo(
    () => [
      { primary: true, type: 'ordinal', position: 'bottom' },
      { position: 'left', type: 'linear', stacked: true }
    ],
    []
  );
  const series = React.useMemo(
    () => ({
      type: 'bar'
    }),
    []
  );
  const data = React.useMemo(
    () => [
      {
        label: 'Series 1',
        dataType: 'ordinal',
        data: [
          ['Sıcaklık', 18],
          ['Gaz', 40]
        ]
      }
    ],
    []
  );
  function getSteps() {
    return ['Ürün Bilgileri', 'Kart İşlemleri', 'Cihaz İşlemleri'];
  }
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleKartBarkodOpen = () => {
    setOpenBarkodkart(true);
  };
  const handleCihazBarkodOpen = () => {
    setOpenBarkodCihaz(true);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <Typography className={classes.title} color="textSecondary">
              Barkod
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {props.Barcode}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {'Model Kodu'}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {props.kulModelKodu}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              Model
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {props.Model}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {'Üretim Yılı'}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {props.Uyil}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              Üretim Dönemi
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {props.Udonem}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {'Seri Numarası'}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {props.SeriNo}
            </Typography>
          </div>
        );
      case 1:
        return (
          <div className={classes.fields}>
            <Paper className={classes.search} elevation={1}>
              <CropFreeIcon
                onClick={handleKartBarkodOpen}
                className={classes.searchIcon}
              />
              <Input
                className={classes.searchInput}
                disableUnderline
                value={KartBarcode}
                onChange={event => {
                  setKartBarcode(event.target.value);
                }}
                placeholder={'Kart Barkodunu Okutunuz!...'}
              />
            </Paper>
          </div>
        );
      case 2:
        return (
          <div className={classes.fields}>
            <Paper className={classes.search} elevation={1}>
              <CropFreeIcon
                onClick={handleCihazBarkodOpen}
                className={classes.searchIcon}
              />
              <Input
                className={classes.searchInput}
                disableUnderline
                value={CihazBarcode}
                onChange={event => {
                  setCihazBarcode(event.target.value);
                }}
                placeholder={'Cihaz Barkodunu Okutunuz!...'}
              />
            </Paper>
          </div>
        );
      default:
        return '';
    }
  }
  const handleKartBarkodClose = async barkod => {
    setKartBarcode(barkod);
    setOpenBarkodkart(false);
  };
  const handleCihazBarkodClose = async barkod => {
    setCihazBarcode(barkod);
    setOpenBarkodCihaz(false);
  };

  const getActionHeader = event => {
    let ReturnValue = (
      <Grid container spacing={1}>
        {SessionUser.TenantId === 12 && (
          <Grid item xs={4} sm={4} lg={4} align="left">
            <IconButton
              edge="end"
              size="small"
              disabled={props.readonly}
              className={classes.action}
              onClick={() => handleVatOpen(props)}
            >
              <Badge
                overlap="circle"
                size="small"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                badgeContent={
                  <SmallAvatar
                    style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                  >
                    +
                  </SmallAvatar>
                }
              >
                <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>
                  {t('V')}
                </Avatar>
              </Badge>
            </IconButton>
          </Grid>
        )}
        <Grid item xs={SessionUser.TenantId === 12 ? 4 : 6} sm={SessionUser.TenantId === 12 ? 4 : 6} lg={SessionUser.TenantId === 12 ? 4 : 6} align="left">
          <IconButton
            edge="end"
            size="small"
            disabled={props.readonly}
            className={classes.action}
            onClick={() => handleExtraOpen(props)}
          >
            <Badge
              overlap="circle"
              size="small"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              badgeContent={
                <SmallAvatar
                  style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                >
                  +
                </SmallAvatar>
              }
            >
              <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>
                {t('T')}
              </Avatar>
            </Badge>
          </IconButton>
        </Grid>
        <Grid item xs={SessionUser.TenantId === 12 ? 4 : 6} sm={SessionUser.TenantId === 12 ? 4 : 6} lg={SessionUser.TenantId === 12 ? 4 : 6} align="right">
          <IconButton
            edge="end"
            size="small"
            disabled={props.readonly}
            className={classes.action}
            onClick={() => handleStokOpen(props)}
          >
            <Badge
              overlap="circle"
              size="small"
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right'
              }}
              badgeContent={
                <SmallAvatar
                  style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                >
                  <DoneIcon />
                </SmallAvatar>
              }
            >
              <Avatar style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}>
                <DeveloperBoardIcon />
              </Avatar>
            </Badge>
          </IconButton>
        </Grid>
      </Grid>
    );
    return ReturnValue;
  };

  const handleChangeKm = event => {

    if (event.target.value < 1) {
      setTotalExtraPrice(0);
      setKm(0);
      setExtraPaymentDetailDsc("");
      return;
    }


    let ExtraPrice = ExtraPaymentTypeData.filter(
      x =>
        parseInt(x.Min) <= parseInt(event.target.value) &&
        parseInt(x.Max) >= parseInt(event.target.value)
    );
    if (ExtraPrice[0]?.Factor === 0) {

      setTotalExtraPrice(ExtraPrice[0]?.Price);
    }

    else if ((SessionUser.TenantId == 58 || SessionUser.TenantId == 62 || SessionUser.TenantId == 12 || SessionUser.TenantId == 37) && ExtraPrice[0]?.Factor === 1) {
      let basePrice = ExtraPaymentTypeData.filter(
        x => x.Factor == 0
      )[0].Price;

      setTotalExtraPrice((ExtraPrice[0]?.Price * (parseInt(event.target.value) - ExtraPrice[0]?.Min)) + basePrice);
    }

    else if ((SessionUser.TenantId === 53 || SessionUser.TenantId == 39 || SessionUser.TenantId == 64) && ExtraPrice[0]?.Factor === 1) {
      setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(event.target.value)));

    }

    else {
      setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(event.target.value) - ExtraPrice[0]?.Min));
    }

    setExtraPaymentDetailDsc(ExtraPrice[0]?.ExtraDesc);
    setKm(event.target.value === '' ? '' : Number(event.target.value));
  };

  const handleSliderChange = (event, newValue) => {
    if (newValue < 1) {
      newValue = 0;
    }
    let ExtraPrice = ExtraPaymentTypeData.filter(
      x =>
        parseInt(x.Min) <= parseInt(newValue) &&
        parseInt(x.Max) >= parseInt(newValue)
    );

    if (ExtraPrice.length > 0) {
      if (ExtraPrice[0]?.Factor === 0) {
        setTotalExtraPrice(ExtraPrice[0]?.Price);
      }

      //Factor changes zero to one, we were losing Factor zero price
      //In order to eleminate adding all of the transport prices for each km in Factor zero
      //We added that change additional table should be added for tenants. --Asaf, Erdem
      else if ((SessionUser.TenantId == 58 || SessionUser.TenantId == 62 || SessionUser.TenantId == 12) && ExtraPrice[0]?.Factor === 1) {
        let basePrice = ExtraPaymentTypeData.filter(
          x => x.Factor == 0
        )[0].Price;

        setTotalExtraPrice((ExtraPrice[0]?.Price * (parseInt(newValue) - ExtraPrice[0]?.Min)) + basePrice);
      }

      else if ((SessionUser.TenantId === 53 || SessionUser.TenantId == 39 || SessionUser.TenantId == 64) && ExtraPrice[0]?.Factor === 1) {
        setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(newValue)));

      }

      else {
        setTotalExtraPrice(ExtraPrice[0]?.Price * (parseInt(newValue) - ExtraPrice[0]?.Min));
      }

      setExtraPaymentDetailDsc(ExtraPrice[0]?.ExtraDesc);
    } else {
      setTotalExtraPrice(0);
      setExtraPaymentDetailDsc("");
    }
    setKm(newValue);
  };



  const deleteExtraPrice = () => {
    let ExtraPrice = ExtraPaymentTypeData.filter(
      x => parseInt(x.Min) <= parseInt(Km) && parseInt(x.Max) >= parseInt(Km)
    );
    let data = {
      Km,
      MaterialId: 0,
      PriceId: 0,
      Price: 0,
      VatRate: 0,
      VatId: 0,
      ExtraPrice: 0,
      WorkOrderId: parseInt(props.ReceiptNo),
      ExtraFeeNote: extraFeeNote,
      EmployeeId: SessionUser.TechnicianId
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetTransport', data, config)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        let TaskTransportData = [
          {
            MaterialId: 0,
            DefectId: 0,
            MaterialCode: 'TRNS',
            Count: Km,
            MaterialDesc: 'Route Payment',
            MaterialPrice: 0,
            MaterialPriceWithWat: 0,
            MaterialPriceId: 0,
            MaterialPriceListId: 0,
            VatRate: 0,
            VatId: 0
          }
        ];
        let TaskExtraData = [
          {
            MaterialId: 0,
            DefectId: 0,
            MaterialCode: 'EXT',
            Count: 1,
            MaterialDesc: 'Extra Payment',
            MaterialPrice: 0,
            MaterialPriceWithWat: 0,
            MaterialPriceId: 0,
            MaterialPriceListId: 0,
            VatRate: 0,
            VatId: 0
          }
        ];

        const TData = props.tasks.tasks.filter(
          d => parseInt(d.ReceiptNo) === parseInt(props.ReceiptNo)
        );
        let job = TData[0];
        job = {
          ...job,
          WorkOrderTransport: TaskTransportData,
          WorkOrderExtra: TaskExtraData,
        };
        props.setTask(job);
        setKm(0);
        setTotalExtraPrice(0);
        setExtraPaymentDetailDsc("");
        setTotalExtraNewPriceParam(0);
        setTotalExtraNewPrice(0);
        setExtraOpen(false);
        setLoading(false);

      })
      .catch(error => {
        setLoading(false);
      });
  };


  const setExtraPrice = () => {
    let ExtraPrice = ExtraPaymentTypeData.filter(
      x => parseInt(x.Min) <= parseInt(Km) && parseInt(x.Max) >= parseInt(Km)
    );



    let data = {
      Km,
      MaterialId: ExtraPrice[0]?.MaterialId || 0,
      PriceId: ExtraPrice[0]?.PriceId || 0,
      Price: parseFloat(TotalExtraPrice) || 0,
      VatRate: ExtraPaymentTypeData[0]?.VatRate || 0,
      VatId: ExtraPaymentTypeData[0]?.VatId || 0,
      ExtraPrice: parseFloat(TotalExtraNewPrice),
      WorkOrderId: parseInt(props.ReceiptNo),
      ExtraFeeNote: extraFeeNote,
      EmployeeId: SessionUser.TechnicianId
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetTransport', data, config)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;

        let TaskTransportData = [
          {
            MaterialId: ExtraPrice[0]?.MaterialId || 0,
            DefectId: 0,
            MaterialCode: 'TRNS',
            Count: Km,
            MaterialDesc: 'Route Payment',
            MaterialPrice: parseFloat(TotalExtraPrice) || 0,
            MaterialPriceWithWat: (parseFloat(TotalExtraPrice) || 0) * (1 + ((ExtraPrice && ExtraPrice.length > 0) ? ExtraPrice[0]?.VatRate : 0)),
            MaterialPriceId: ExtraPrice[0]?.PriceId || 0,
            MaterialPriceListId: 0,
            VatRate: ExtraPrice[0]?.VatRate || 0,
            VatId: ExtraPrice[0]?.VatId || 0
          }
        ];
        let TaskExtraData = [
          {
            MaterialId: 0,
            DefectId: 0,
            MaterialCode: 'EXT',
            Count: 1,
            MaterialDesc: 'Extra Payment',
            MaterialPrice: parseFloat(TotalExtraNewPrice),
            MaterialPriceWithWat: parseFloat(TotalExtraNewPrice) * (1 + ((ExtraPaymentTypeData && ExtraPaymentTypeData.length > 0) ? ExtraPaymentTypeData[0]?.VatRate : 0)),
            MaterialPriceId: 0,
            MaterialPriceListId: 0,
            VatRate: ExtraPaymentTypeData[0]?.VatRate || 0,
            VatId: ExtraPaymentTypeData[0]?.VatId || 0
          }
        ];




        const TData = props.tasks.tasks.filter(
          d => parseInt(d.ReceiptNo) === parseInt(props.ReceiptNo)
        );
        let job = TData[0];
        job = {
          ...job,
          WorkOrderTransport: TaskTransportData,
          WorkOrderExtra: TaskExtraData
        };
        props.setTask(job);
        setExtraOpen(false);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const AddExtraPriceNew = (e) => {
    setTotalExtraNewPrice(e.target.value);
    setTotalExtraNewPriceParam(e.target.value)
  }

  const SetExtraNote = (e) => {
    setExtraFeeNote(e.target.value);
  }


  //serdar
  const setPriceControlChangePopup = () => {
    var AlertPrice = t('iscilik_Toplami') + " : " + moneyFormat(props?.tasks?.tasks[0]?.LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit)
      + " - " + t('malzeme_Toplami') + " : " + moneyFormat(props?.tasks?.tasks[0]?.MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit)
      + " - " + t('yan_odeme_Toplami') + " : " + moneyFormat(props?.tasks?.tasks[0]?.TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit)
      + " - " + t('lblExtraTotal') + " : " + moneyFormat(props?.tasks?.tasks[0]?.ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit)
      + " - " + t('Toplam') + " : " + moneyFormat(props?.tasks?.tasks[0]?.TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit);
    setUyari(AlertPrice);
    setOpen(true);
    return;
  }

  const handleBackButtonClick = () => {
    setBackButtonVisible(false);
    GetMaterialAvailabilityOwnEngineer(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Card className={classes.cardsMax}>
        <Snackbar
          open={Uyari}
          autoHideDuration={6000}
          onClose={uyariKapat}
        >
          <Alert
            onClose={uyariKapat}
            severity="warning"
            message={uyariAciklama || ''}
            variant={uyariTip}
          ></Alert>
        </Snackbar>
        {PriceControlButton ? <Button
          variant="contained"
          color="primary"
          style={{ backgroundColor: 'red' }}
          onClick={() => setPriceControlChangePopup()}
          className={classes.submitButtonWudaq}
          endIcon={<LocalAtmIcon>Get</LocalAtmIcon>}
        >
          {t('lblPriceChangeControl')}
        </Button>
          : ""}

        <CardHeader
          avatar={
            <IconButton
              edge="end"
              size="small"
              disabled={props.readonly}
              onClick={() => setOpenDefect(true)}
            >
              <Badge
                overlap="circle"
                size="small"
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                badgeContent={
                  <SmallAvatar
                    style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                  >
                    +
                  </SmallAvatar>
                }
              >
                <Avatar
                  style={{ backgroundColor: '#1D3343', color: '#FFFFFF' }}
                >
                  {t('D')}
                </Avatar>
              </Badge>
            </IconButton>
          }
          title={<Typography variant="h6">{t('HizmetEkle')} </Typography>}
          action={getActionHeader(data)}
        />
        <Paper style={{ maxHeight: 270, overflow: 'auto' }}>
          <List component="div" dense>
            {props.defects.selected &&
              props.defects.selected.map((row, index) => {
                if (!props.defects.defectsTable) return null;
                const dd = props.defects.defectsTable[row];
                const montaj = dd?.DefectTypeCode === 3;
                return (
                  dd && (
                    <Box key={row} borderRadius={16} {...defaultProps}>
                      <ListItem key={row}>
                        <ListItemText
                          primary={
                            <Typography variant="h6">
                              {dd.CategoryLevel2 + ', ' + dd.DefectType + ' - ' + dd.DefectDesc}
                            </Typography>
                          }
                        />
                        {!props.readonly && (
                          <div>
                            <IconButton
                              edge="end"
                              size="small"
                              disabled={props.readonly}
                              onClick={() => {
                                props.setCurrentDefect(row);
                                setOpenLabour(true);
                              }}
                            >
                              <Badge
                                overlap="circle"
                                size="small"
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'right'
                                }}
                                badgeContent={
                                  <SmallAvatar
                                    style={{
                                      backgroundColor: '#1D3343',
                                      color: '#FFFFFF'
                                    }}
                                  >
                                    +
                                  </SmallAvatar>
                                }
                              >
                                <Avatar
                                  style={{
                                    backgroundColor: '#1D3343',
                                    color: '#FFFFFF'
                                  }}
                                >
                                  {t('L')}
                                </Avatar>
                              </Badge>
                            </IconButton>
                            <IconButton
                              edge="end"
                              size="small"
                              disabled={props.readonly}
                              onClick={() => {
                                props.setCurrentDefect(row);
                                setOpenMaterial(true);
                              }}
                            >
                              <Badge
                                overlap="circle"
                                size="small"
                                anchorOrigin={{
                                  vertical: 'bottom',
                                  horizontal: 'right'
                                }}
                                badgeContent={
                                  <SmallAvatar
                                    style={{
                                      backgroundColor: '#1D3343',
                                      color: '#FFFFFF'
                                    }}
                                  >
                                    +
                                  </SmallAvatar>
                                }
                              >
                                <Avatar
                                  style={{
                                    backgroundColor: '#1D3343',
                                    color: '#FFFFFF'
                                  }}
                                >
                                  {t('M')}
                                </Avatar>
                              </Badge>
                            </IconButton>
                          </div>
                        )}
                      </ListItem>
                      <Box borderRadius={16} {...defaultPropsChild}>
                        {props.labours[row] &&
                          props.labours[row]?.map((mrow, index) => (
                            <ListItem dense={true} key={mrow}>
                              <SwipeableListItem
                                dense={true}
                                swipeLeft={{
                                  content: (
                                    <ComplexSwipeContent
                                      icon={<DeleteSweepIcon />}
                                      label={t('SilButon')}
                                      position="right"
                                      css="hizmet"
                                    />
                                  ),
                                  action: () =>
                                    IscilikSil(
                                      props.labours.laboursTable[mrow],
                                      index,
                                      row
                                    )
                                }}
                                blockSwipe={props.readonly}
                              >
                                <ListItemText>
                                  <Typography
                                    key={mrow}
                                    variant="body1"
                                    className={classes.nestedRight}
                                  >
                                    <b>{mrow + ' '}</b>
                                    {props.labours?.laboursTable[mrow]?.LabourDesc}
                                  </Typography>
                                </ListItemText>
                                <ListItemSecondaryAction
                                  className={classes.nested}
                                >
                                  {
                                    SessionUser.ServiceShopPriceVisible ? <Typography variant="h6">
                                      {moneyFormat(
                                        props.labours.laboursTable[mrow]?.Price,
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                      )}
                                      {' ' + SessionUser.CurrencyUnit}
                                    </Typography>
                                      : null}

                                </ListItemSecondaryAction>
                              </SwipeableListItem>
                            </ListItem>
                          ))}
                      </Box>
                      <Box borderRadius={16} {...defaultPropsChild}>
                        {props.materials[row] &&
                          props.materials[row].map((mrow, index) => (
                            <ListItem dense={true} key={mrow}>
                              <SwipeableListItem
                                dense={true}
                                swipeLeft={{
                                  content: (
                                    <ComplexSwipeContent
                                      icon={<DeleteSweepIcon />}
                                      label={t('SilButon')}
                                      position="right"
                                      css="hizmet"
                                    />
                                  ),
                                  action: () =>
                                    MalzemeSil(
                                      props.materials.materialsTable[mrow],
                                      index,
                                      row
                                    )
                                }}
                                blockSwipe={props.readonly}
                              >
                                <ListItemText>
                                  <Typography
                                    key={mrow}
                                    variant="body1"
                                    className={classes.nestedRight}
                                  >
                                    <b>{mrow}</b>
                                    {' ' +
                                      props.materials.materialsTable[mrow]?.MaterialDesc +
                                      ' Ref:' +
                                      props.materials.materialsTable[mrow]?.Ref}
                                  </Typography>
                                  <Divider />
                                </ListItemText>
                                <ListItemSecondaryAction
                                  className={classes.nested}
                                >
                                  {
                                    SessionUser.ServiceShopPriceVisible ? <Typography variant="h6">
                                      {moneyFormat(
                                        props.materials.materialsTable[mrow]?.Price,
                                        SessionUser.TenantCode,
                                        SessionUser.CurrencyUnit
                                      )}
                                      {' ' + SessionUser.CurrencyUnit}
                                      <br />
                                      <Typography variant="body1">
                                        {(props.materials[mrow] || '1') +
                                          ' ' +
                                          t('lblAdet')}
                                      </Typography>
                                    </Typography> : null}

                                </ListItemSecondaryAction>
                              </SwipeableListItem>
                            </ListItem>
                          ))}
                      </Box>
                    </Box>
                  )
                );
              })}
          </List>
        </Paper>
        <Divider />
        {
          SessionUser.ServiceShopPriceVisible ?
            <Grid container spacing={0}>
              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('iscilik_Toplami')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom>
                  {moneyFormat(
                    labourVatSum,
                    SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom>
                  {SessionUser.CurrencyUnit}
                </Typography>
              </Grid>
              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('malzeme_Toplami')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom>
                  {moneyFormat(
                    materialVatSum,
                    SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom>
                  {SessionUser.CurrencyUnit}
                </Typography>
              </Grid>
              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('yan_odeme_Toplami')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom>
                  {moneyFormat(
                    props.tasks.tasks[0]?.WorkOrderTransport.length === 0
                      ? '0.00'
                      : props.tasks.tasks[0]?.WorkOrderTransport[0]
                        ?.MaterialPrice || 0.0,
                    SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom>
                  {SessionUser.CurrencyUnit}
                </Typography>
              </Grid>
              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom
                >
                  {t('lblExtraTotal')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom>
                  {moneyFormat(
                    props.tasks.tasks[0]?.WorkOrderExtra.length === 0
                      ? '0.00'
                      : props.tasks.tasks[0]?.WorkOrderExtra[0]
                        ?.MaterialPrice || 0.0,
                    SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom>
                  {SessionUser.CurrencyUnit}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider variant="inset" />
              </Grid>

              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom style={{ color: 'red' }}
                >
                  {SessionUser.TenantCode == 71 || SessionUser.TenantCode == 72 ? t('lblGstTotal') : t('lblVatTotal')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                  {moneyFormat(
                    (materialSum +
                      labourSum +
                      (props.tasks.tasks[0]?.WorkOrderTransport.length > 0
                        ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPriceWithWat || 0
                        : 0)
                      +
                      (props.tasks.tasks[0]?.WorkOrderExtra.length > 0
                        ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPriceWithWat || 0
                        : 0))
                    -
                    (
                      (materialSum +
                        labourSum +
                        (props.tasks.tasks[0]?.WorkOrderTransport.length > 0
                          ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPriceWithWat || 0
                          : 0)
                        +
                        (props.tasks.tasks[0]?.WorkOrderExtra.length > 0
                          ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPriceWithWat || 0
                          : 0))
                      -
                      (materialVatSum +
                        labourVatSum +
                        (props.tasks.tasks[0]?.WorkOrderTransport.length > 0
                          ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPrice || 0
                          : 0)
                        +
                        (props.tasks.tasks[0]?.WorkOrderExtra.length > 0
                          ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPrice || 0
                          : 0)) || 0

                    )


                    , SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                  {` ${SessionUser.CurrencyUnit}`}
                </Typography>
              </Grid>

              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom style={{ color: 'red' }}>
                  {SessionUser.TenantId == 71 || SessionUser.TenantId == 72 || SessionUser.TenantId == 48 ? t('lblGst') : t('lblVat')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                  {moneyFormat(
                    (materialSum +  //Sub Total
                      labourSum +
                      (props.tasks.tasks[0]?.WorkOrderTransport.length > 0
                        ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPriceWithWat || 0
                        : 0)
                      +
                      (props.tasks.tasks[0]?.WorkOrderExtra.length > 0
                        ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPriceWithWat || 0
                        : 0))
                    -
                    (materialVatSum +  //Vat
                      labourVatSum +
                      (props.tasks.tasks[0]?.WorkOrderTransport.length > 0
                        ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPrice || 0
                        : 0)
                      +
                      (props.tasks.tasks[0]?.WorkOrderExtra.length > 0
                        ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPrice || 0
                        : 0)) || 0
                    , SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                  {` ${SessionUser.CurrencyUnit}`}
                </Typography>
              </Grid>

              <Grid item xs={9} align="right">
                <Typography
                  className={classes.title}
                  color="textSecondary"
                  gutterBottom style={{ color: 'red' }}
                >
                  {t('Toplam')}
                </Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                  {moneyFormat(
                    materialSum +
                    labourSum +
                    (props.tasks.tasks[0]?.WorkOrderTransport.length > 0
                      ? props.tasks.tasks[0]?.WorkOrderTransport[0]?.MaterialPriceWithWat || 0
                      : 0)
                    +
                    (props.tasks.tasks[0]?.WorkOrderExtra.length > 0
                      ? props.tasks.tasks[0]?.WorkOrderExtra[0]?.MaterialPriceWithWat || 0
                      : 0)
                    , SessionUser.TenantCode,
                    SessionUser.CurrencyUnit
                  )}
                </Typography>
              </Grid>
              <Grid item xs={1} align="center">
                <Typography variant="h6" gutterBottom style={{ color: 'red' }}>
                  {` ${SessionUser.CurrencyUnit}`}
                </Typography>
              </Grid>
            </Grid> :
            null
        }

        <br />
        <SelectDefect
          open={openDefect}
          onClose={() => setOpenDefect(false)}
          ReceiptNo={props.ReceiptNo}
          title={t('hizmet_secimi')}
        />
        <SelectMaterial
          open={openMaterial}
          onClose={() => {
            setOpenMaterial(false);
            setMaterialFilterKey('');
            setGosterimAdet(30);
          }}
          title={t('malzeme_secimi')}
          ReceiptNo={props.ReceiptNo}
          GosterimAdet={GosterimAdet}
          setGosterimAdet={setGosterimAdet}
          ProductCode={props.kulModelKodu}
          defect={props.defects.currentDefect}
        />
        <SelectLabour
          open={openLabour}
          onClose={() => {
            setOpenLabour(false);
            setLabourFilterKey('');
          }}
          garantiTipi={props.garantiTipi}
          title={t('iscilik_secimi')}
          ReceiptNo={props.ReceiptNo}
          defect={props.defects.currentDefect}
        />
        <Dialog
          open={ExtraOpen}
          fullWidth
          maxWidth="xs"
          onClose={() => setExtraOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t('lblYanOdeme')}
            <Divider />
          </DialogTitle>
          <DialogContent>
            <Card>
              <CardHeader title={t('lblTransport')} />
              <Divider />
              <CardContent>
                {loading ? <CircularProgress status="loading" style={{ marginLeft: '50%' }} /> : (
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <br />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Slider
                        value={typeof Km === 'number' ? Km : 0}
                        onChange={handleSliderChange}
                        aria-labelledby="input-slider"
                        step={SessionUser.TenantId === 75 ? 0.1 : 1} //for Pakistan
                        valueLabelDisplay="on"
                        min={0}
                        max={ExtraPaymentTypeData[0]?.MaxKm || 130}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        id="outlined-number"
                        label={t('Km')}
                        size="small"
                        type="number"
                        // onBlur={handleBlur}
                        inputProps={{
                          step: 1,
                          min: 0,
                          max: ExtraPaymentTypeData[0]?.MaxKm,
                          type: 'number',
                          'aria-labelledby': 'input-slider',
                          style: { textAlign: 'right' }
                        }}
                        fullWidth
                        value={Km}
                        onChange={handleChangeKm}
                        variant="outlined"
                      />
                    </Grid>
                    {
                      SessionUser.ServiceShopPriceVisible ?
                        <>
                          <Grid item xs={12} sm={9} lg={9}>
                            <TextField
                              disabled
                              size="small"
                              id="outlined-disabled"
                              label={t('lblPrice')}
                              variant="outlined"
                              fullWidth
                              value={moneyFormat(
                                TotalExtraPrice,
                                SessionUser.TenantCode,
                                SessionUser.CurrencyUnit
                              )}
                              inputProps={{
                                style: { textAlign: 'right' }
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={3} lg={3}>
                            <TextField
                              disabled
                              size="small"
                              id="outlined-disabled"
                              label={SessionUser.TenantId == 71 || SessionUser.TenantId == 72 || SessionUser.TenantId == 48 ? t('lblGst') : t('lblVat')}
                              variant="outlined"
                              fullWidth
                              value={'%' + ExtraPaymentTypeData[0]?.VatRate * 100}
                              inputProps={{
                                style: { textAlign: 'right' }
                              }}
                            />
                          </Grid>
                        </> : null
                    }

                    <Grid item xs={12} sm={12} lg={12}>
                      <Typography variant="h6" gutterBottom>
                        {t('lblExtraPaymentDetailDsc')}
                      </Typography>
                    </Grid>
                  </Grid>
                )}

              </CardContent>
            </Card>
            {!loading && (
              <Card>
                <CardHeader title={t('lblExtra')} />
                <Divider />
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        id="outlined-disabled"
                        label={t('lblPrice')}
                        variant="outlined"
                        onChange={e => AddExtraPriceNew(e)}
                        fullWidth
                        value={TotalExtraNewPriceParam}
                        inputProps={{
                          style: { textAlign: 'right' }
                        }}
                      />

                    </Grid>
                    <Grid item xs={12} sm={9} lg={9}>
                      <TextField
                        size="small"
                        disabled
                        id="outlined-disabled"
                        label={t('lblPrice')}
                        variant="outlined"
                        onChange={e => AddExtraPriceNew(e)}
                        fullWidth
                        value={moneyFormat(
                          TotalExtraNewPrice,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        )}
                        inputProps={{
                          style: { textAlign: 'right' }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <TextField
                        disabled
                        size="small"
                        id="outlined-disabled"
                        label={SessionUser.TenantId == 71 || SessionUser.TenantId == 72 || SessionUser.TenantId == 48 ? t('lblGst') : t('lblVat')}
                        variant="outlined"
                        fullWidth
                        value={'%' + ((ExtraPaymentTypeData && ExtraPaymentTypeData[0]?.VatRate) ? ExtraPaymentTypeData[0]?.VatRate : 0) * 100}
                        inputProps={{
                          style: { textAlign: 'right' }
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        id="outlined-disabled"
                        label={t('lblNote')}
                        variant="outlined"
                        onChange={e => SetExtraNote(e)}
                        fullWidth
                        value={extraFeeNote}
                        inputProps={{
                          style: { textAlign: 'left' }
                        }}
                      />

                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => setExtraPrice()}
              endIcon={<SendIcon>Close</SendIcon>}
            >
              {t('lblEkle')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => deleteExtraPrice()}
              endIcon={<DeleteIcon>Delete</DeleteIcon>}
            >
              {t('SilButon')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => setExtraOpen(false)}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              {t('lblClose')}
            </Button>
          </DialogActions>

        </Dialog>
        <Dialog
          open={SoftwareDownloadOpen}
          onClose={() => setSoftwareDownloadOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            Cihaz Kart Yükleme
            <Divider />
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                  <StepContent>
                    <br />
                    <br />
                    {getStepContent(index)}
                    <br />
                    <br />
                    <div className={classes.actionsContainer}>
                      <div>
                        <Button
                          disabled={activeStep === 0}
                          variant="contained"
                          style={{
                            backgroundColor: '#1D3343',
                            color: '#424242'
                          }}
                          onClick={handleBack}
                          startIcon={<KeyboardArrowLeft />}
                          className={classes.button}
                        >
                          Back
                        </Button>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleNext}
                          endIcon={<KeyboardArrowRight />}
                          className={classes.button}
                        >
                          {activeStep === steps.length - 1
                            ? 'YazılımYükle'
                            : 'İlerİ'}
                        </Button>
                      </div>
                    </div>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
            {activeStep === steps.length && (
              <Paper square elevation={0} className={classes.resetContainer}>
                <Typography>
                  İşleminiz Başarı ile Gerçekleştirildi...
                </Typography>
                <Button onClick={handleReset} className={classes.button}>
                  Başa Dön
                </Button>
              </Paper>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setSoftwareDownloadOpen(false)}
              className={classes.submitButtonWudaq}
              endIcon={<CloseIcon>Close</CloseIcon>}
            >
              {t('Kapat')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={NonIotOpen}
          onClose={() => setNonIotOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {t('Cihaz_Ariza_Bilgileri')}
            <Divider />
          </DialogTitle>
          <DialogContent>
            {grafikGetir ? (
              <img src={'/images/wudaq.gif'} alt="nice"></img>
            ) : (
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <div
                    style={{
                      height: '400px'
                    }}
                  >
                    <Chart data={data} series={series} axes={axes} />
                  </div>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setNonIotChartOpen()}
                  className={classes.submitButtonWudaq}
                  endIcon={<SettingsRemoteIcon>Getir</SettingsRemoteIcon>}
                >
                  {t('Bilgileri_getir')}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setNonIotOpen(false)}
                  className={classes.submitButtonWudaq}
                  endIcon={<CloseIcon>Close</CloseIcon>}
                >
                  {t('Kapat')}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          open={stokOpen}
          onClose={() => setStokOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {t('Malzeme_Stok_Durumu')}
            <Divider />
          </DialogTitle>
          <DialogContent>
            <List component="div" dense>
              {loading ? (
                <CircularProgress status="loading" style={{ marginLeft: '50%' }} />
              ) : (
                <>
                  {/* stokDataOwnEngineer */}
                  {serviceShopTypeId === 1 ? (
                    <>
                      {stokDataOwnEngineer.length > 0 ? (
                        <>
                          <Typography>{t('VanStock')}</Typography>
                          {stokDataOwnEngineer.map((s, index) => (
                            <React.Fragment key={index}>
                              <ListItem fullWidth alignItems="flex-start">
                                <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                                <ListItemText
                                  primary={
                                    <Typography variant="body1" className={classes.nestedRight}>
                                      <b>{s.MaterialCode}</b>
                                    </Typography>
                                  }
                                  secondary={
                                    <>
                                      <Typography
                                        component="span"
                                        variant="h6"
                                        className={classes.inline}
                                        color="textPrimary"
                                      >
                                        {t('OwnEngineer')} : {s.StorageLocation}
                                        <br />
                                        {t('lblAdet')} : {s.Quantity}
                                        <br />
                                        {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : '-'}
                                        <br />
                                        {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 ? (
                                          <div>
                                            {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity === 0 ? '-' : moment(s.ETA).format('DD/MM/YYYY')}
                                          </div>
                                        ) : null}
                                      </Typography>
                                    </>
                                  }
                                />
                              </ListItem>
                              <Divider variant="inset" component="li" />
                            </React.Fragment>
                          ))}
                        </>
                      ) : (
                        <Typography>{stockMsg}</Typography>
                      )}
                    </>
                  ) : null}
                  <Divider variant="inset" component="li" />
                  {/* stokData */}
                 {virtualStockEnabledLoaded && virtualStockEnabled ? (
                  stokData.map((s, index) => (
                    <div>
                      <Typography variant="h6" style={{ paddingLeft: 6, paddingTop: 8 }}>
                        {s.MaterialCode}
                      </Typography>
                      <VirtualStockPanel
                        key={s.MaterialCode}
                        loading={false}
                        total={s.virtualTotal || 0}
                        invoices={s.virtualInvoices || []}
                        expanded={expandedPanel === s.MaterialCode}
                        onToggle={() => togglePanel(s.MaterialCode)}
                        t={t}
                        showTitle={false} // <-- disables lblVirtualStock heading for DefectPage
                      />
                    </div>
                  ))
                ) : (
                  stokData.length > 0 && IsAllOwnEngineer == false ? stokData.map((s, index) => (
                    <React.Fragment key={index}>
                      <ListItem fullWidth alignItems="flex-start">
                        <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              variant="body1"
                              className={classes.nestedRight}
                            >
                              <b>{s.MaterialCode}</b>
                            </Typography>
                          }
                          secondary={
                            <React.Fragment>
                              <Typography component="span" variant="h6" className={classes.inline} color="textPrimary">
                                {t('StorageDesc')} : {s.StorageLocation}
                                <br />
                                {t('lblAdet')} : {s.Quantity}
                                <br />
                                {t('Tarih')} : {s.Date != null ? moment(s.Date).format('DD/MM/YYYY') : "-"}
                                <br />
                                {SessionUser.TenantId === 87 || SessionUser.TenantId === 16 && (
                                  <div>
                                    {t('ETA')} : {s.ETA === new Date(0).getTime() || s.Quantity == 0 ? "-" : moment(s.ETA).format('DD/MM/YYYY')}
                                  </div>
                                )}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </React.Fragment>
                  )) : ''
                )}
                </>
              )}
            </List>
          </DialogContent>
          <DialogActions>
            {serviceShopTypeId == 1 ? <div>
              {backButtonVisible ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleBackButtonClick}
                >
                  {t('lblBack')}
                </Button>
              ) :
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => StockSearch(false)}
                >
                  {t('lblFieldStock')}
                </Button>
              }
            </div> : ''}
            <Button
              variant="contained"
              color="primary"
              onClick={() => setStokOpen(false)}
            >
              {t('Tamam')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={VatOpen}
          fullWidth
          maxWidth="xs"
          onClose={() => setVatOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{t('VatType')}</DialogTitle>
          <Divider />
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel id="vat-select-label">{t('VatType')}</InputLabel>
              <Select
                labelId="vat-select-label"
                value={selectedVat}
                onChange={handleVatChange}
                size="small"
              >
                {vatRates.map((rate) => (
                  <MenuItem key={rate.Id} value={rate.Id}>
                    {rate.Code}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </DialogContent>
        </Dialog>
        <BarkodPopup
          onClose={handleKartBarkodClose}
          open={OpenBarkodkart}
          ScanTime={1000}
        />
        <BarkodPopup
          onClose={handleCihazBarkodClose}
          open={OpenBarkodCihaz}
          ScanTime={1000}
        />
      </Card>
    </div>
  );
}

const mapStateToProps = state => ({
  defects: state.defectReducer,
  materials: state.materialReducer,
  labours: state.labourReducer,
  tasks: state.tasks1
});

const mapDispatchToProps = {
  setCurrentDefect,
  setDefectFilterKey,
  setLabourFilterKey,
  setMaterialFilterKey,
  setMaterialSelection,
  setLabourSelection,
  getHistoricalMaterialRequest,
  setTask,
  resetLabours,
  resetMaterials,
  resetDefects,
  getDefectRequest,
  getLabourRequest,
  getMaterialRequest
};
mapStateToProps.propTypes = {
  className: PropTypes.string
};

export default connect(mapStateToProps, mapDispatchToProps)(HizmetPage);
